export const AGE_GROUP_CATEGORIES = ['U13', 'U15', 'U17', 'U19', 'First Team'] as const

export function getAgeBasedTeamCategory(age?: number | null) {
  if (typeof age !== 'number' || Number.isNaN(age)) {
    return 'First Team'
  }

  if (age <= 13) return 'U13'
  if (age <= 15) return 'U15'
  if (age <= 17) return 'U17'
  if (age <= 19) return 'U19'
  return 'First Team'
}

export function normalizeTeamCategory(category?: string | null) {
  const value = (category || '').trim()
  if (!value) return 'First Team'

  const upper = value.toUpperCase()
  if (upper.includes('13')) return 'U13'
  if (upper.includes('15')) return 'U15'
  if (upper.includes('17')) return 'U17'
  if (upper.includes('19')) return 'U19'
  if (upper.includes('FIRST')) return 'First Team'

  return value
}

export function resolveTeamCategory(category?: string | null, age?: number | null) {
  const normalized = normalizeTeamCategory(category)
  const ageBased = getAgeBasedTeamCategory(age)

  if (normalized === 'First Team' && ageBased !== 'First Team') {
    return ageBased
  }

  return normalized
}
